export default {
  ADD_NORMATIVE_ACTS (state, docs) {
    state.documents = docs
  },
  ADD_NEW_NORMATIVE_ACT (state, doc) {
    state.documents.push(doc)
  },
  DELETE_NORMATIVE_ACT (state, id) {
    state.documents = state.documents.filter(d => d.id !== id)
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations/normativeActs.js